import { FC, MouseEvent } from 'react';
import { Icon } from 'learning-panel-components';
import styles from './tag.module.scss';

const Tag: FC<TagProps> = (props: TagProps) => {
    const { name, count, onClick, isSelected, showExpandMoreIcon } = props;
    return (
        <div
            className={isSelected ? styles.selected : styles.tag}
            onClick={(event: MouseEvent<HTMLDivElement>) => onClick(event)}
        >
            <div className={styles.name}>{name}</div>
            <div>{`(${count})`}</div>
            {showExpandMoreIcon && <Icon name="downArrowIcon" className={styles.expand} />}
        </div>
    );
};

export default Tag;

interface TagProps {
    name: string;
    count: number;
    onClick: (event: MouseEvent<HTMLDivElement>) => void;
    isSelected?: boolean;
    showExpandMoreIcon?: boolean;
}
